import React from "react";
import { RefreshCw } from "lucide-react";
import { STATUS_OPTIONS } from "@/pages/admin/contact/constants";

/**
 * Quick filter pills (All + every pipeline status) with the count badge.
 * Includes the refresh button on the right.
 */
const StatusFilter = ({
  filter,
  onChange,
  items,
  refreshing,
  onRefresh,
  lang,
}) => {
  const ALL = { v: "all", fr: "Toutes", en: "All", color: "#F2EBE5" };
  const pills = [ALL, ...STATUS_OPTIONS];

  const countFor = (v) =>
    v === "all" ? items.length : items.filter((x) => x.status === v).length;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-wrap items-center gap-2">
        {pills.map((s) => (
          <button
            key={s.v}
            onClick={() => onChange(s.v)}
            data-testid={`admin-filter-${s.v}`}
            className={`text-[10px] uppercase tracking-[0.25em] px-3 py-2 border transition-colors ${
              filter === s.v
                ? "border-[#C5A059] text-[#C5A059] bg-[#C5A059]/5"
                : "border-[#F2EBE5]/15 text-[#A19E9C] hover:text-[#F2EBE5] hover:border-[#F2EBE5]/30"
            }`}
          >
            {lang === "fr" ? s.fr : s.en} ({countFor(s.v)})
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={onRefresh}
        disabled={refreshing}
        data-testid="admin-contact-refresh"
        className="kw-btn-ghost"
      >
        <RefreshCw
          className={`w-3.5 h-3.5 ${refreshing ? "animate-spin" : ""}`}
          strokeWidth={1.5}
        />
        {lang === "fr" ? "Actualiser" : "Refresh"}
      </button>
    </div>
  );
};

export default StatusFilter;
